
import HttpClient from '../HttpService';


function generateReport(data) {
    return HttpClient.post('/reports', data);
}

function generateClimateSurveyReport(data) {
	// data = { company, competence, group }
	return HttpClient.post('/reports/climate-survey', data);
}

export default {
	generateClimateSurveyReport,
    generateReport
}
